export default __webpack_public_path__ + "static/Avenir-Heavy-1c62bc5a817a9e630019764d1e1af982.otf";